import { render, staticRenderFns } from "./Drops.vue?vue&type=template&id=4d00278a&"
import script from "./Drops.vue?vue&type=script&lang=js&"
export * from "./Drops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports